/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './PreferencesSection.scss';

import classnames from 'classnames';
import { bool, node } from 'prop-types';
import React from 'react';

const PreferencesSection = ({ children, className, fullBackground }) => (
  <div
    className={classnames(
      'preferences-section',
      { 'full-background': fullBackground },
      className
    )}>
    {children}
  </div>
);

PreferencesSection.propTypes = {
  children: node.isRequired,
  fullBackground: bool.isRequired
};

PreferencesSection.defaultProps = {
  fullBackground: false
};

export default PreferencesSection;
